export class MessageTemplate {
    constructor(public mtType?, public mTemplate?) {}
}